import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/react-hooks';
import {
  ArticleGroupAiImagesJobsInProgressQuery,
  ArticleGroupAiImagesJobsInProgressQueryVariables
} from './__generated__/ArticleGroupAiImagesJobsInProgressQuery';
import { kmsClient } from '../../apollo';

export const ARTICLE_GROUP_IMAGES_JOBS_IN_PROGRESS_QUERY = gql`
  query ArticleGroupAiImagesJobsInProgressQuery($id: ID!) {
    articleGroup(id: $id) {
      hasArticleGroupsAiImagesJobsInProgress
    }
  }
`;

export const useArticleGroupAiImagesJobsInProgressLazyQuery = () => {
  return useLazyQuery<ArticleGroupAiImagesJobsInProgressQuery, ArticleGroupAiImagesJobsInProgressQueryVariables>(
    ARTICLE_GROUP_IMAGES_JOBS_IN_PROGRESS_QUERY,
    { client: kmsClient, fetchPolicy: 'network-only' }
  );
};
